import { render, staticRenderFns } from "./popular_key_words.vue?vue&type=template&id=ed97f684"
import script from "./popular_key_words.vue?vue&type=script&lang=js"
export * from "./popular_key_words.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports